import React from "react";
import { ButtonText, PrimaryButton } from "Buttons";
import { Icon } from "./MenuComponents";
export const LoginButton = ({ theme, ProfilePage, FirstName }) => {
	return (
		<PrimaryButton
			href={ProfilePage}
			inverted={true}
			bgColorhover={theme.colors.lightgreen}
			width="135px"
			widthsmall="135px"
			heightsmall="40px"
			margin="0"
			height="40px"
			noBorderLeftOnHover
		>
			<Icon className="icon-user-fill" />
			<ButtonText forcedFontSize="16px" forcedFontSizeSmall="16px">
				{FirstName}
			</ButtonText>
		</PrimaryButton>
	);
};
